import {
  GET_STATES_ATTEMPT,
  GET_STATES_SUCCESS,
  GET_STATES_FAILURE,
} from "../constants";

import { StatesInitialState } from "../../types/states";

const initialState: StatesInitialState = {
  fetchingStatesList: 0,
  errorMessage: "",
  success: true,
  statesList: [],
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    // getStates
    case GET_STATES_ATTEMPT:
      return {
        ...state,
        fetchingStatesList: state.fetchingStatesList + 1,
        success: true,
        errorMessage: "",
      };
    case GET_STATES_SUCCESS:
      return {
        ...state,
        fetchingStatesList: state.fetchingStatesList - 1,
        success: true,
        errorMessage: "",
        statesList: validData(action.payload.data),
      };
    case GET_STATES_FAILURE:
      return {
        ...state,
        fetchingStatesList: state.fetchingStatesList - 1,
        success: false,
        errorMessage: action.payload.error,
      };

    default:
      return state;
  }
};

function validData (data: any[]) {
  return data.filter((element: any) => element.state)
}
